import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config/config.service';
import { ConfigViewModelService } from 'src/app/services/configViewModel/config-view-model.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { ColumnInfo, PreviewTableComponent } from '../../../preview-table/preview-table.component';
import { ActivityNamingRule, ActivityNamingRuleType } from 'src/app/domainObjects/transformers/activityNamingTransform';
import { DataConnectorMapping } from 'src/app/domainObjects/dataConnectorMapping';
import { DataTransformerConfig } from 'src/app/domainObjects/dataTransformConfig';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { LogicOperatorType } from 'src/app/domainObjects/logicalOperatorType';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { ColoredTextItem } from 'src/app/domainObjects/coloredTextItem';
import { ActivityNamingRuleViewModel } from './activityNamingRuleViewModel';
import { ActivityNamingTransformDetailViewModel, GroupStartAtTypeUtil, GroupEndAtTypeUtil } from './activityNamingTransformDetailViewModel';
import { BaseTransformerUIComponent } from '../../../dataTransformConfig/transformers/base/base-transformer-ui/base-transformer-ui.component';
import { TransformPipelineService } from '../../../../services/transformPipeline/transform-pipeline.service';
import { DataDictionaryService } from '../../../../services/dataDictionary/data-dictionary.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormBuilder, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DataTransformConfigViewModel } from '../../../../viewModels/dataTransformConfigViewModel';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { TransformRuleViewModel } from 'src/app/viewModels/transformRuleViewModel';
import { UserDataService } from 'src/app/services/user-data-service';
import { RefineryPresenceService } from 'src/app/services/refinery-presence.service';
import { TransformType, TransformTypeUtil } from 'src/app/domainObjects/transformType';
import { ParameterSetting } from 'src/app/domainObjects/masterConfig';
import { TransformerTopHeaderComponent } from '../../transformer-top-header/transformer-top-header.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { InputPrvwFilterViewModel } from 'src/app/viewModels/inputPrvwFilterViewModel';
import { SaveCurrntTransfrmcacheRequest } from 'src/app/messaging/saveCurrntTransfrmcacheRequest';
import { DataFarmTypeUtil } from 'src/app/domainObjects/dataFarmType';
import { collectDistinctSourceFields } from 'src/app/views/shared/utils/source-field.util';

@Component({
    selector: 'app-activity-naming-transform-detail',
    templateUrl: './activity-naming-transform-detail.component.html',
    styleUrls: ['./activity-naming-transform-detail.component.css'],
    standalone: false
})
export class ActivityNamingTransformDetailComponent extends BaseTransformerUIComponent<ActivityNamingTransformDetailViewModel>
  implements OnInit {

  /** Distinct fields referenced by this config's rules, Default Source Field first — Smart Sample dropdown. */
  get activityNamerAvailableSourceFields(): string[] {
    const defaultField = this.viewModel?.parameters?.sourceColumn;
    const fromRules = collectDistinctSourceFields(this.viewModel?.rules, r => r.sourceColumn);
    if (!defaultField) return fromRules;
    return [defaultField, ...fromRules.filter(f => f !== defaultField)];
  }

  selectedIndex: number = 0;
  isResultsPanelExpanded = false;
  isPreviewPanelExpanded = false;   
  transformerInputPreviewCacheKey = ""; 
  dataSource: MatTableDataSource<ActivityNamingRuleViewModel>;
  previewDataViewModel: ImportDataViewModel;
  isRuleSetEmpty = true;
  isRuleExecuting = false;
  RuleType = ActivityNamingRuleType;
  GroupStartAtTypeUtil = GroupStartAtTypeUtil;
  GroupEndAtTypeUtil = GroupEndAtTypeUtil;
  LogicalOperatorType = LogicOperatorType;

  StartsAtRuleTypes = [
    ActivityNamingRuleType.group,
    ActivityNamingRuleType.contains,
    ActivityNamingRuleType.emptyGroup
  ];

  EndsAtRuleTypes = [
    ActivityNamingRuleType.group,
    ActivityNamingRuleType.contains
  ];

  displayedColumns: string[] = [
    'actions',
    'index',
    'ruleName',
    'sourceColumn',
    'startsAt',
    'endsAt',
    'activityName',
    'contains',
    'includeAfter',
    'timeout',
    'logicalOperator',
    'matchCase',
    'isEnabled',
    'sampleGroups',
    'sampleRows',
    'groups',
    'rows'];

  isRulesMaximized = false;

  inputPrvwFilterViewModel = new InputPrvwFilterViewModel();

  sortCtrl = new UntypedFormControl('');
  form: FormGroup;
  formparam: FormGroup;

  constructor(
    activeRoute: ActivatedRoute,
    errorService: ErrorReportingService,
    matDialog: MatDialog,
    snackBar: MatSnackBar,
    router: Router,
    configViewModelService: ConfigViewModelService,
    configService: ConfigService,
    navService: NavigationService,
    transformPipelineService: TransformPipelineService,
    userData: UserDataService,
    dataDictService: DataDictionaryService,
    refineryPresence: RefineryPresenceService,
    private cdRef: ChangeDetectorRef,private fb: FormBuilder) {

      super(activeRoute, errorService, matDialog, snackBar, router, configViewModelService, configService, navService, transformPipelineService, userData,dataDictService, refineryPresence);
      this.transformType = TransformType.activityNamer;
  }
  //other parameters
  groupBy: ParameterSetting=new ParameterSetting();
  defContainsInclude: ParameterSetting=new ParameterSetting();
  defTimeout: ParameterSetting=new ParameterSetting();
  //advanced settings parameters
  bufferRows: ParameterSetting=new ParameterSetting();
  threads: ParameterSetting=new ParameterSetting();
  orderField: ParameterSetting=new ParameterSetting();
  isOpenField: ParameterSetting=new ParameterSetting();
  isCloseField: ParameterSetting=new ParameterSetting();
  multiTargetColumn: ParameterSetting=new ParameterSetting();
  noGroupId: ParameterSetting=new ParameterSetting();
  // noGroupIdTimeout: ParameterSetting=new ParameterSetting();
  separateBy: ParameterSetting=new ParameterSetting();

  @ViewChild(TransformerTopHeaderComponent) topHeaderComponent: TransformerTopHeaderComponent;
  transformType:TransformType;
   options: string[] =[];
   defaultSourceColumn='Source Field';
  ngOnInit(): void {
    super.ngOnInit();
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.resetInputPrvwViewModel();
    this.transformerInputPreviewCacheKey = "";
    //validation
    this.formparam= this.fb.group({
      groupByField: [null, [Validators.required]],
    });
    this.registerFormGroup(this.formparam);
    this.form = this.fb.group({
      bufferRows: ['', []],
      threads: ['', []],
      orderField: [null, []],
      isOpenField: [null, []],
      isCloseField: [null, []],
      noGroupId: ['', []],
      // noGroupIdTimeout: ['', []],
      separateBy: [null, []],
    });
    this.registerFormGroup(this.form);
    this.totalRulesColumnDisplay();
  }

  protected override async onRouteActivated(_routeParams: any): Promise<void> {
    this.viewModel = new ActivityNamingTransformDetailViewModel(
      this.dataDictService,
      this.configService,
      this.dataTransformConfigViewModel,
      this.transformViewModel);
    this.viewModel.farmType=this.userData.getSelectedNodeDetails().farmtypeid;
    this.configureTargetColumnsFarmtypeid(this.userData.getSelectedNodeDetails().farmtypeid);
    this.snapshotPreState();

    this.dataSource = new MatTableDataSource<ActivityNamingRuleViewModel>(this.viewModel.rules);
    this.isRuleSetEmpty = this.viewModel.rules.length === 0;

    if (this.previewTable) { this.previewTable.clear(); }
    if (this.outputDataFarmPreviewTable) { this.outputDataFarmPreviewTable.clear(); }

    await this.setTransformerDetails(this.transformType);
    await this.downloadInputDataAsync();
    this.viewModel.parameters.sourceColumns = this.viewModel.sourceColumns;
    this.options=[...this.viewModel.sourceColumns.map(col => col.text).sort((a, b) => a.localeCompare(b))];
    this.viewModel.parameters.targetColumns=this.viewModel.targetColumns;
    await this.setDefaultValues(this.transformType);
    await this.removeInvalidValues();
  }

  onTransformTextChanged(){
    this.viewModel.transformViewModel.name=this.viewModel.transform.name;
    var currenttransform=this.dataTransformConfigViewModel.transforms.find(x=>x.guid==this.viewModel.transform.guid);
    currenttransform.name=this.viewModel.transform.name;
    currenttransform.transform.name=this.viewModel.transform.name;
    var vartransform=this.transformslists.find(x=>x.guid==this.viewModel.transform.guid);
    vartransform.name=this.viewModel.transform.name;
  }
  dropTable(event: CdkDragDrop<MatTableDataSource<TransformRuleViewModel>>): void {
    const prevIndex = event.previousIndex;
    const currentItem: ActivityNamingRuleViewModel = event.item.data;
    currentItem.index = prevIndex;
    moveItemInArray(this.viewModel.rules, prevIndex, event.currentIndex);
    this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.rules;
  }
  
  onRunChanged(event: MatSlideToggleChange): void {
    this.viewModel.rules.forEach( r => r.run = event.checked);
  }

  toggleRulesHeight(): void {
    this.isRulesMaximized = !this.isRulesMaximized;
  }

  onDeleteRule(rule: ActivityNamingRuleViewModel): void {
    this.showConfirmDialog('Delete Confirmation', `Are you sure you want to delete this rule?`, (confirmed) => {
      if (confirmed) {
        const index = this.viewModel.rules.indexOf(rule);
        this.viewModel.rules.splice(index, 1);
        this.viewModel.reindexRules();
        
        this.dataSource.data = this.viewModel.rules;
        this.isRuleSetEmpty = this.viewModel.rules.length === 0;
        //update rule table height
        if(this.viewModel.rules.length<=10){
          this.minrowcount=this.viewModel.rules.length;
        }else{
          this.minrowcount=10;
        }
        this.maxrowcount=this.viewModel.rules.length;
      }
    });
  }

  onDuplicateRule(sourceRule: ActivityNamingRuleViewModel): void {
    
    const vm = new ActivityNamingRuleViewModel(sourceRule.toRule());

    this.viewModel.rules.splice(sourceRule.index, 0, vm);
    this.viewModel.reindexRules();
    this.dataSource.data = this.viewModel.rules;
    
    //update rule table height
    if(this.viewModel.rules.length<=10){
      this.minrowcount=this.viewModel.rules.length;
    }else{
      this.minrowcount=10;
    }
    this.maxrowcount=this.viewModel.rules.length;
    if(vm.index==this.maxrowcount){this.isScrollBottom=true; }else{this.isScrollBottom=false;}
  }
  minrowcount:number=10;
  maxrowcount:number=100;
  isScrollBottom:boolean=true;
  addNewRule(): void {
    var isValidDefaultParam=true;
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==this.transformType);
    var params=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid).parameters.filter(n=>n.isruledefault==true);
    params.forEach(field => {
      if(field.jsonobject=="defSourceField"){
        if(!this.viewModel.parameters.sourceColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="defTargetField"){
        if(!this.viewModel.parameters.targetColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="userIdField"){
        if(!this.viewModel.parameters.userColumn){
          isValidDefaultParam=false;
        }
      }
      else if(field.jsonobject=="timestampField"){
        if(!this.viewModel.parameters.timeColumn){
          isValidDefaultParam=false;
        }
      }
    });

    if (!isValidDefaultParam) {
      this.displayError("Cannot add Rule unless Default field(s) are entered.","Please fix the validation error.");
      return;
    }
    const id = this.viewModel.rules.length;
    const rule = new ActivityNamingRule();
    rule.ruleId = null;
    rule.index = id;
    rule.sourceField = this.viewModel.parameters.sourceColumn;
    rule.targetField = this.viewModel.parameters.targetColumn;
    rule.includeAfter = this.viewModel.defContainsInclude;
    rule.timeout = this.viewModel.defTimeout;
    rule.andOr=false;//set or as default
    rule.matchCase=true;
    rule.run=true;
    if (!rule.startsAt && this.StartsAtRuleTypes.length > 0) {
      rule.startsAt = this.StartsAtRuleTypes[0];
    }
    if (!rule.endsAt && this.EndsAtRuleTypes.length > 0) {
      rule.endsAt = this.EndsAtRuleTypes[0];
    }
    const vm = new ActivityNamingRuleViewModel(rule);

    this.viewModel.rules.push(vm);
    this.isRuleSetEmpty = false;
    this.dataSource.data = this.viewModel.rules;

    //update rule table height
    if(this.viewModel.rules.length<=10){
      this.minrowcount=this.viewModel.rules.length;
    }else{
      this.minrowcount=10;
    }
    this.maxrowcount=this.viewModel.rules.length; 
  }

  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, colInfos: ColumnInfo[]): string {
    try {
      return this.getClassForRowBase(sender, row, colInfo, colInfos);
    } catch (err) {
      return null;
    }
  }

  onContainsCellClicked(rule: ActivityNamingRuleViewModel): void {
    let title: string=`Contains Editor Rule ${rule.index}`;
    let label: string="Contains";
    let placeholder: string="Enter Value";
    let fieldType: string ="edit";
    let isDuplicateRemoved: boolean =false;
    let canAddNewAutocomplete: boolean =false;
    let options: string[] = [];
    let dialogWidth: string='400px'
    this.showTextEditorDialogOption(title, label,placeholder,fieldType,isDuplicateRemoved,canAddNewAutocomplete,options,dialogWidth, 
      rule.containsList,
      async (items: ColoredTextItem[],eventname:string) => {
      if(eventname=='save'){
        rule.containsList = items;
      }
    });
  }

  async saveConfig(): Promise<void> {
    if (!this.validate()) {
      return;
    }
   if (!await this.validateRules()) {
      this.displayError("Validation failed. Please correct the highlighted fields in:\n" + this.invalidRules.join("\n"),"Validation Error");
      return;
    }
    if (this.dataTransformConfigViewModel.dataTransformerConfig?.id || this.dataTransformConfigViewModel.dataTransformerConfig?.guid) {
      this.saveConfigImpl(this.dataTransformConfigViewModel.dataTransformerConfig.name);
    } else {
      this.showSaveConfigDialog(async (configName: string) => {
        this.saveConfigImpl(configName);
      });
    }
  }

  async saveConfigImpl(configName: string): Promise<void> {
       var currenttransformer_sampleStart = this.viewModel.parameters.sampleStart ;
      var currenttransformer_sampleEnd = this.viewModel.parameters.sampleEnd  ;
    
        if (currenttransformer_sampleStart >=  currenttransformer_sampleEnd) {
            this.displayWarning(
              'Sample Start was greater than to Sample End, so it was auto-reset to 1.',
              'Warning',
              undefined,
              () => {
                this.viewModel.parameters.sampleStart = 1;
              }
            );
            return;
          }
          if(currenttransformer_sampleStart > this.totalInputRows || currenttransformer_sampleEnd > this.totalInputRows )
        {
    
          this.displayWarning(
            'Sample Range exceeded the Input Farm size and was auto-corrected to the maximum limit.',
            'Warning',
            undefined,  // no exception to pass
            () => {
           
              if (currenttransformer_sampleStart > this.totalInputRows) {
              this.viewModel.parameters.sampleStart = 1;
              }
              if (currenttransformer_sampleEnd > this.totalInputRows) {
                this.viewModel.parameters.sampleEnd = this.totalInputRows;
              }
            }
          );
          return;
        }
      
    const busyIndicator = this.showBusyDialog('Please wait...');
    try {
      let config = this.dataTransformConfigViewModel.dataTransformerConfig ?? new DataTransformerConfig();

      config.name = configName;
      config.organizationId = 1;
      config.dataSourceType = this.dataTransformConfigViewModel.dataSourceType;
      config.selectedIngestFarmGuid = this.dataTransformConfigViewModel.selectedIngestFarmGuid;
      
      // Save the Data Connectors
      config.dataConnectorMappings = this.dataTransformConfigViewModel.ingestConfigs
      .map ( ingestConfig =>
        new DataConnectorMapping(
          ingestConfig.id,
          ingestConfig.name,
          ingestConfig.targetDataFarm,
          ingestConfig.dataConnector.toDataConnector(),
          ingestConfig.columnMap
            .map(i => i.toColumnMapDefinition()),
          ingestConfig.guid,
          ingestConfig.masterColumnMapGuid)
      );

      // Save Transforms
      config.transforms = this.dataTransformConfigViewModel.transforms.map(t => t.transform);

      // Save the transform
      //const transform = config.transforms.find(t => t.id === this.viewModel.transform?.id) ?? this.viewModel.transformViewModel.transform;
      const transform = this.viewModel.transformViewModel.transform;

      transform.transformConfig = this.viewModel.toTransformConfig();
      // transform.dataFarmName = this.viewModel.dataFarm.name;
      // transform.dataFarmType = this.viewModel.dataFarm.dataFarmType;

      // TODO: Maintain list of transforms for this config
      const existingTransform = config.transforms.find(t => t.guid === transform.guid);
      if (existingTransform) {
        config.transforms.splice(config.transforms.indexOf(existingTransform), 1);
      }
      config.transforms.push(transform);
      
      // Save the ingest transforms

      config = await this.configService.upsertConfig(config);
      this.userData.setSelectedConfigJson(config);
      this.configViewModelService.setDataTransformConfigViewModel(new DataTransformConfigViewModel(config));
      this.userData.setSelectedTransform(this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid));
      //update preViewModel
      this.snapshotPreState();


      // SAve the current node status to Not RunConfigRequest.
      const selectedNode = this.userData.getSelectedNodeDetails();
      // const RefineryConfigJson = await this.configService.getRefineryConfigByGuidAsync(selectedNode.refineryConfigGuid);
      // RefineryConfigJson.nodes.filter(newNode => newNode.id == selectedNode.id)[0].data.nodeStatus = NodeRunStatus.NotRun
      // let RefineryJson = await this.configService.UpsertRefineryConfig(RefineryConfigJson);
      
      // var UpdateNodesStatus: UpdateNodesStatusRequest = new UpdateNodesStatusRequest(selectedNode.refineryConfigGuid, selectedNode.id, NodeRunStatus.PipelineModified )
      // let updateStatusreturn = await this.configService.updateUpcomingNodesStatus(UpdateNodesStatus);
      
      //Invoke the save current transformer cache api
       const activeTransformGuid = this.userData.getSelectedTransform().guid
       const userId = this.userData.getUserId()
       const orgId = this.userData.getOrgId()
       var saveCurrentTransformerCacheRequest: SaveCurrntTransfrmcacheRequest = new SaveCurrntTransfrmcacheRequest(userId, orgId, selectedNode.id, selectedNode.refineryConfigGuid, this.dataTransformConfigViewModel.selectedIngestFarmGuid, activeTransformGuid);
       await this.configService.saveCurrentTransformerCache(saveCurrentTransformerCacheRequest);
       await this.configService.getRefineryConfigByGuidAsync(this.userData.getRefineryId());
       this.getCacheStatus();
      // this.cdRef.detectChanges();
      this.snackBar.open(`Successfully saved transform pipeline '${this.userData.getSelectedTransform().name}'`, 'Dismiss', {
        duration: 5000
      });
    } catch (err) {
      this.displayError(`Failed to save '${this.userData.getSelectedTransform().name}'`, 'Error', err);
    } finally {
      busyIndicator.close();
    }
  }
  onSetDefaultRule(defaultfield:string){
    if(defaultfield=="sourceColumn"){
      this.viewModel.rules.forEach(rule=>{
        rule.sourceColumn=this.viewModel.parameters.sourceColumn;
      })
    }
    else if(defaultfield=="targetColumn"){
      this.viewModel.rules.forEach(rule=>{
        rule.targetColumn=this.viewModel.parameters.targetColumn;
      })
    }
  }
  totalRulesColumnDisplay(){
    //blank values
    this.viewModel.rules.forEach(rule=>{
      rule.groupHits=null;
      rule.rowHits=null;
    })
    if(this.viewModel.parameters.runAll){
      this.displayedColumns= [
        'actions',
      'index',
      'ruleName',
      'sourceColumn',
      'startsAt',
      'endsAt',
      'activityName',
      'contains',
      'includeAfter',
      'timeout',
      'logicalOperator',
      'matchCase',
      'isEnabled',
      'sampleGroups',
      'sampleRows',
      'groups',
      'rows'];
      }else{
      this.displayedColumns= [
        'actions',
        'index',
        'ruleName',
        'sourceColumn',
        'startsAt',
        'endsAt',
        'activityName',
        'contains',
        'includeAfter',
        'timeout',
        'logicalOperator',
        'matchCase',
        'isEnabled',
        'sampleGroups',
        'sampleRows'];
    }
    this.cdRef.detectChanges();
  }
  onToggleRulesColumnDisplay(){
    this.totalRulesColumnDisplay();
  }
  onToggleMultiTarget(event: any){
    this.viewModel.multiTargetColumn=event.checked;
  }
  onParameterFormStatusChange(status: boolean) {
    this.isParameterFormValid = status;
  }
  
  checkContainsListLength(rule: any): boolean {
    return !rule.containsList || rule.containsList.length <= 1;
  }

  onTabClick(event: MatTabChangeEvent): void {
    const selectedTabIndex = event.index;
    const selectedTabLabel = event.tab.textLabel;
    this.selectedIndex = selectedTabIndex;
 
    // Alert the tab index and label
   // alert(`Tab clicked: ${selectedTabLabel} (Index: ${selectedTabIndex})`);
   this.userData.setResultsTabClicked(false);
   if(selectedTabLabel.match("Output") && selectedTabIndex == 1) {
    this.userData.setOutputTabClicked(true)
    this.setOutputPreviewTabSlctnStatus();
   } else {
      this.userData.setOutputTabClicked(false);
      this.setInputPreviewFilterViewModel();
   }
  }

  setActivityNamerResultsTabClicked() {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    
    this.userData.setOutputTabClicked(false);
    this.userData.setResultsTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    this.isResultsPanelExpanded = true;
    this.isPreviewPanelExpanded = false;
  }

  setActivityNamerPreviewTabClicked() {
    if(this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey.length > 0) {
      this.transformerInputPreviewCacheKey = this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey;
    }
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(false);
    this.isResultsPanelExpanded = false;
    this.isPreviewPanelExpanded = true;
    if(this.selectedIndex == 0) {
      this.setInputPreviewFilterViewModel();
    }
    if(this.selectedIndex == 1) {
      this.setOutputPreviewTabSlctnStatus();
    }
  }

  setOutputPreviewTabSlctnStatus(): void {
    this.userData.setResultsTabClicked(false);
    this.userData.setOutputTabClicked(true);
    this.resetTransformerInputPrvwModelData();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
  }

  setInputPreviewFilterViewModel() {
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.setTransformerInputPrvwCacheKey();
    this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel)
  }
  
  setTransformerInputPrvwCacheKey() {
    if(this.transformerInputPreviewCacheKey.length > 0 && this.inputPrvwFilterViewModel.farmId.length > 0) {
      this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = this.transformerInputPreviewCacheKey;
      this.userData.setInputTabDataFrFilter(this.inputPrvwFilterViewModel);
    }
  }

  resetInputPrvwViewModel() {
    this.inputPrvwFilterViewModel.farmId = "";
    this.inputPrvwFilterViewModel.collookupFarmId = "";
    this.inputPrvwFilterViewModel.nodeType = "";
    this.inputPrvwFilterViewModel.previewType = "TransformerInput";
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
  }

  resetTransformerInputPrvwModelData() {
    this.inputPrvwFilterViewModel.transfrmrInputprvwCacheKey = "";
    this.inputPrvwFilterViewModel.previewType = "";
  }
  
  get isValidateParameters(): boolean {
    return !(this.isParameterFormValid && this.formparam.valid);
  }
  get isValidateAdvanceSettings(): boolean {
    return this.form.invalid;
  }
  async setDefaultValues(transformType:TransformType): Promise<void>{
    const selectedNode=this.userData.getSelectedNodeDetails();
    const masterconfig=this.userData.getMasterTransformers().find(x=>x.id==transformType);
    var parameters=masterconfig.parameters.find(x=>x.farmtypeid==selectedNode.farmtypeid);
    if(parameters){
      var params=parameters.parameters;
      //other parameters
      this.groupBy=params.find(x=>x.jsonobject=='groupBy');
      this.defContainsInclude=params.find(x=>x.jsonobject=='defContainsInclude');
      this.defTimeout=params.find(x=>x.jsonobject=='defTimeout');
      //advanced settings parameters
      this.bufferRows=params.find(x=>x.jsonobject=='bufferRows');
      this.threads=params.find(x=>x.jsonobject=='threads');
      this.orderField=params.find(x=>x.jsonobject=='orderField');
      this.isOpenField=params.find(x=>x.jsonobject=='isOpenField');
      this.isCloseField=params.find(x=>x.jsonobject=='isCloseField');
      this.multiTargetColumn=params.find(x=>x.jsonobject=='multiTargetColumn');
      this.noGroupId=params.find(x=>x.jsonobject=='noGroupId');
      // this.noGroupIdTimeout=params.find(x=>x.jsonobject=='noGroupIdTimeout');
      this.separateBy=params.find(x=>x.jsonobject=='separateBy');
      //check this is first this.viewModel.sampleEnd =0
      if((this.viewModel.sampleEnd-1)==0 || isNaN(this.viewModel.sampleEnd)){
        if(this.multiTargetColumn.default!=""){
          this.viewModel.multiTargetColumn=this.stringToBoolean(this.multiTargetColumn.default);
        }
      //other parameters
        for(let pr of this.groupBy.default.split(";")){
          const foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == pr);
          if(foundColumn){
            this.viewModel.groupBy=foundColumn.value;
            break;
          }
        }
        if(this.defContainsInclude.default!=""){
          this.viewModel.defContainsInclude=Number(this.defContainsInclude.default);
        }
        if(this.defTimeout.default!=""){
          this.viewModel.defTimeout=Number(this.defTimeout.default);
        }
      //advanced settings parameters
        if(this.bufferRows.default!=""){
          this.viewModel.bufferRows=Number(this.bufferRows.default);
        }
        if(this.threads.default!=""){
          this.viewModel.threads=Number(this.threads.default);
        }
        for(let pr of this.orderField.default.split(";")){
          const foundColumn = this.viewModel.targetColumns.find(sc => sc == pr);
          if(foundColumn){
            this.viewModel.orderField=foundColumn;
            break;
          }
        }
        for(let pr of this.isOpenField.default.split(";")){
          const foundColumn = this.viewModel.targetColumns.find(sc => sc == pr);
          if(foundColumn){
            this.viewModel.isOpenField=foundColumn;
            break;
          }
        }
        for(let pr of this.isCloseField.default.split(";")){
          const foundColumn = this.viewModel.targetColumns.find(sc => sc == pr);
          if(foundColumn){
            this.viewModel.isCloseField=foundColumn;
            break;
          }
        }
        if(this.noGroupId.default!=""){
          this.viewModel.noGroupId=this.noGroupId.default;
        }
        // if(this.noGroupIdTimeout.default!=""){
        //   this.viewModel.noGroupIdTimeout=Number(this.noGroupIdTimeout.default);
        // }
        for(let pr of this.separateBy.default.split(";")){
          const foundColumn = this.viewModel.targetColumns.find(sc => sc == pr);
          if(foundColumn){
            this.viewModel.separateBy=foundColumn;
            break;
          }
        }
      }
    }else{
      //advanced settings parameters
      // this.bufferRows.label="Buffer Rows";this.bufferRows.jsonobject="bufferRows";this.bufferRows.min=0;this.bufferRows.max=10000000;
      // this.threads.label="Threads (0 > Auto)";this.threads.jsonobject="threads";this.threads.min=0;this.threads.max=64;
      // this.resetRows.label="Reset Row Numbers";this.resetRows.jsonobject="resetRows";
    }
  }
  async removeInvalidValues(): Promise<void>{
    //other parameters
    //advanced settings parameters
    var isvalid=true;
    var foundColumn = this.viewModel.sourceColumns.find(sc => sc.value == this.viewModel.groupBy);  
    if(!foundColumn){
      isvalid=false;
      this.viewModel.groupBy=undefined;
    }
    
    // if(!isvalid){//later to work now it show two warning msg as in on common parameter and here on
    //   this.displayWarning("One or more fields in the configuration are  not in the input farm.","Warning.");
    // }
  }
  async loadImportTransformer(transform: any): Promise<void>{
    const busyIndicator = this.showBusyDialog('Please wait...');
    try{
      if(this.userData.getSelectedNodeDetails().farmtypeid!=transform.farmType){
        this.displayError("Current DataFarmType is " + DataFarmTypeUtil.toString(this.userData.getSelectedNodeDetails().farmtypeid) + ". But you are trying to load a different DataFarmType: " + DataFarmTypeUtil.toString(transform.farmType),"Error");
        return;
      }else if(this.transformType!=transform.transformType){
        this.displayError("Current transform is " + TransformTypeUtil.toString(this.transformType) + ". But you are trying to load a different transform type: " + TransformTypeUtil.toString(transform.transformType),"Error");
        return;
      }
      var ctranformconfig=this.dataTransformConfigViewModel.transforms.find(x=>x.guid=== this.userData.getSelectedTransform().guid);
      ctranformconfig.transform.transformConfig=transform;
      var newmodel =new ActivityNamingTransformDetailViewModel(this.dataDictService,this.configService,this.dataTransformConfigViewModel,ctranformconfig);
      // force new object reference for UI refresh
      this.viewModel.rules=[];
      this.viewModel.rules=[...newmodel.rules];
      this.isRuleSetEmpty = this.viewModel.rules.length === 0;
      this.dataSource.data = this.viewModel.rules;
      //update Parameters
      this.viewModel.parameters.sourceColumn=newmodel.parameters.sourceColumn;
      this.viewModel.parameters.targetColumn=newmodel.parameters.targetColumn;
      this.viewModel.parameters.userColumn=newmodel.parameters.userColumn;
      this.viewModel.parameters.timeColumn=newmodel.parameters.timeColumn;
      this.viewModel.parameters.sortInfo=newmodel.parameters.sortInfo;
      this.viewModel.parameters.includeInResults=newmodel.parameters.includeInResults;
      this.viewModel.parameters.sampleStart =newmodel.parameters.sampleStart;
      this.viewModel.parameters.sampleEnd =newmodel.parameters.sampleEnd;
      this.viewModel.parameters.runAll =newmodel.parameters.runAll;
      this.viewModel.parameters.deleteMisses =newmodel.parameters.deleteMisses;
      this.viewModel.parameters.missName =newmodel.parameters.missName;
      //other parameters
      this.viewModel.groupBy = newmodel.groupBy;
      this.viewModel.defContainsInclude = newmodel.defContainsInclude;
      this.viewModel.defTimeout = newmodel.defTimeout;
      //advanced settings parameters
      this.viewModel.bufferRows = newmodel.bufferRows;
      this.viewModel.threads = newmodel.threads;
      this.viewModel.orderField = newmodel.orderField;
      this.viewModel.isOpenField = newmodel.isOpenField;
      this.viewModel.isCloseField = newmodel.isCloseField;
      this.viewModel.separateBy = newmodel.separateBy;
      this.viewModel.noGroupId = newmodel.noGroupId;
      // this.viewModel.noGroupIdTimeout = newmodel.noGroupIdTimeout;
      this.viewModel.multiTargetColumn = newmodel.multiTargetColumn;
      //update rule table height
      if(this.viewModel.rules.length<=10){
        this.minrowcount=this.viewModel.rules.length;
      }else{
        this.minrowcount=10;
      }
      this.maxrowcount=this.viewModel.rules.length;
    }catch (err) {
      this.displayError(`Failed to save import transformer`, 'Error', err);
    }finally {
      busyIndicator.close();
    }
  }

  /** The rules the last check found incomplete ("Rule 2: Name"), for the message. */
  invalidRules: string[] = [];
  async validateRules(): Promise<boolean> {
    var isValidRule = true;
    this.invalidRules = [];
    for (const rule of this.viewModel.rules) {
      if (!TransformRuleViewModel.enabledRules([rule]).length) {
        // A rule that is off is not run, so it is not checked (and shows no highlight).
        rule.tooltipMessageresult = ''; rule.tooltipTyperesult = '';
        rule.tooltipMessageContains = ''; rule.tooltipTypeContains = '';
        continue;
      }
      const result = (rule.result ?? '').trim();

      if (!result) {
        rule.tooltipMessageresult = "Activity Name is required.";
        rule.tooltipTyperesult = "red";
        isValidRule = false;
      }else{
        rule.tooltipMessageresult = '';
        rule.tooltipTyperesult = '';
      }

      if (rule.containsList.length==0) {
        rule.tooltipMessageContains = "Contains is required.";
        rule.tooltipTypeContains = "red";
        isValidRule = false;
      }else{
        rule.tooltipMessageContains = '';
        rule.tooltipTypeContains = '';
      }
      if (!result || rule.containsList.length==0) {
        this.invalidRules.push(TransformRuleViewModel.label(rule));
      }
    }
    return isValidRule;
  }
  getTooltipStyleActivityName(rule:ActivityNamingRuleViewModel): { [klass: string]: string } {
    if (!rule.tooltipMessageresult) return {};

    switch (rule.tooltipTyperesult) {
      case 'red':
        return { 'background-color': '#940000' };
      default:
        return {};
    }
  }
  getTooltipStyleContains(rule:ActivityNamingRuleViewModel): { [klass: string]: string } {
    if (!rule.tooltipMessageContains) return {};

    switch (rule.tooltipTypeContains) {
      case 'red':
        return { 'background-color': '#940000' };
      default:
        return {};
    }
  }
  async onRunTransformValidate() {
    if(!await this.validateRules()){
      this.displayError("Validation failed. Please correct the highlighted fields in:\n" + this.invalidRules.join("\n"),"Validation Error");
      return;
    }
    await this.onRunTransform();
  }
}
